import React from "react";
import GamesSec from "./GamesSec";
import GamingStats from "./GamingStats";
import Numbers from "./Number";
import Footer from "../common/Footer";
import Header from "../common/header";
import Banner from "./banner";
import Watchvideos from "./Watchvideos";
import Rewards from "./Rewards";

const Esport: React.FC = () => {
  return (
   <div className="w-full h-full bg-[#070B28]">
      {/* Fixed Header */}
      <Header />
      <Banner />
      <GamesSec />
      <GamingStats />
      <Watchvideos />
      <Rewards />
      <Numbers />
      <Footer />
    </div>
  );
};

export default Esport;
